export default __webpack_public_path__ + "static/media/i070vp.9c3f37e8.webp";